import React from "react";
import { Link } from "react-router-dom";
import { app } from './firebaseconfig'
import Header1 from './Header'
import './assets/css/main.css'
import SignUp from "./SignUp";
import ReactDOM from 'react-dom';
import ExampleComponent from "react-rounded-image";
import Footer from "./Footer"


class MainPage extends React.Component{
	constructor() {
		super();
		this.state = ({
		  user: null,
		});
		this.authListener = this.authListener.bind(this);
	  }
	
	  componentDidMount() {
		this.authListener();
	  }
	
	  authListener() {
		app.auth().onAuthStateChanged((user) => {
		  if (user) {
			this.setState({ user });
			localStorage.setItem('user', user.uid);
		  } else {
			this.setState({ user: null });
			localStorage.removeItem('user');
		  }
		});
	  }
    
   logout = () => {
        app.auth().signOut().then(function() {
          }).catch(function(error) {
            console.log(error)
		  });
		  window.location.reload(false);
    } 

    loggedin = () => {
        app.auth().onAuthStateChanged(function(user) {
            if (user) {
              return true
            } else {
              return false
            }
        });
    }

//onClick={logout}
//{app.auth().currentUser ? (<h4>Welcome to the MainPage</h4> ) : (<h4>You need to login to upload docs</h4>)}<br></br>
//<h3>Welcome to the MainPage</h3><br></br>
          //  { app.auth().currentUser ? (<h4>You are logged in</h4> ) : (<h4>You need to login to upload docs</h4>)}<br></br>
           // <Link to="/Upload_Your_Documents"> Click to upload your documents</Link><br></br>
           // <Link to="/Documents"> Documents</Link><br></br>
           // <Link to="/Login"> Login</Link><br></br>
           // <Link to="/Signup"> Signup</Link><br></br>
           // <button  onClick={this.logout}> Logout</button>
render(){
    return (
      <>

<head>
		<title>UOB Notes</title>
		<meta charset="utf-8" />
		<meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no" />
		<link rel="stylesheet" href="assets/css/main.css" />
		<script data-ad-client="ca-pub-6388089627501969" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
	</head>
	<body className="landing is-preload">
		<div id="page-wrapper">

			
				<Header1></Header1>
 
			
				<section id="banner">
				<center>	<img src="/images/finalLogo2.png" className="logo1"/></center>
					<b><h2>UOB Notes</h2></b><br></br>
					<p>Studying Made Easier</p>
					<ul className="actions special">
						<li><a href="/Upload_Your_Documents" className="button">Upload Your Documents</a></li>
						{	
							this.state.user ? 
							(<div></div>) : 
							(<li><a href="/Signup" className="button primary">Sign Up</a></li>)
						}
					</ul>
				</section>

				<section id="main" className="container">
				<section className="box special features">
						<div className="features-row">
							<section>
								<img src="/images/Business Adminstration Logo.png" className="logo2"/>
								<h3>College of Business Adminstration</h3>
								<a href="/Business" className="button alt">Show Documents</a>
							</section>
							<section>
							<img src="/images/Arts Logo.png" className="logo2"/>
								<h3>College of Arts</h3>
								<a href="/Arts" className="button alt">Show Documents</a>
							</section>
						</div>
						<div className="features-row">
							<section>
							<img src="/images/IT Logo.png" className="logo2"/>
								<h3>College of Information Technology</h3>
								<a href="/IT" className="button alt">Show Documents</a>
							</section>
							<section>
							<img src="/images/Engineering Logo.png" className="logo2"/>
								<h3>College of Engineering</h3>
								<a href="/Engineering" className="button alt">Show Documents</a>
							</section>
						</div>
					</section>
					</section>
					
					<br></br>
					<br></br>

					<section id="main" className="container">
					<section className="box special features">
							<div className="features-row">
								<section>
									<img src="/images/Law Logo.png" className="logo2"/>
									<h3>College of Law</h3>
									<a href="/Law" className="button alt">Show Documents</a>
								</section>
								<section>
								<img src="/images/Sciences Logo.png" className="logo2"/>
									<h3>College of Science</h3>
									<a href="/Science" className="button alt">Show Documents</a>
								</section>
							</div>
							<div className="features-row">
								<section>
								<img src="/images/Health sciences logo.png" className="logo2"/>
									<h3>College of Health and Sport Sciences</h3>
									<a href="/HealthSportSciences" className="button alt">Show Documents</a>
								</section>
								<section>
								<img src="/images/Teachers logo.png" className="logo2"/>
									<h3>Bahrain Teachers<br></br> College</h3>
									<a href="/BTC" className="button alt">Show Documents</a>
									<br></br><br/><br/>
								</section>
								
								<img src="/images/Sciences logo.png" className="logo2"/>
									<h3>College of<br></br> Applied Studies</h3>
									<a href="/appliedStudies" className="button alt">Show Documents</a>
							</div>
						</section>
					
					</section>
					
					<section id="cta">
						
				</section>

		
				<Footer></Footer>
			

		</div>

		
			<script src="assets/js/jquery.min.js"></script>
			<script src="assets/js/jquery.dropotron.min.js"></script>
			<script src="assets/js/jquery.scrollex.min.js"></script>
			<script src="assets/js/browser.min.js"></script>
			<script src="assets/js/breakpoints.min.js"></script>
			<script src="assets/js/util.js"></script>
			<script src="assets/js/main.js"></script>

	</body>
          </>
    );
};
}
export default MainPage;